import ReactComponent from '../app/ReactComponent'
import {Button, Card, Col, Layout, Result, Row, Spin} from 'antd'
import React, {createRef} from 'react'
import {Link} from 'react-router-dom'
import {randomString} from '../helpers/utils'
import {PROPERTY_AP_SURVEY_KEY} from '../helpers/properties'
import {AP_SURVEY_ANNUAL_EVENT_TYPE_ID, AP_SURVEY_REGISTRATION_EVENT_TYPE_ID, AP_SURVEY_GUIDE_EVENT_TYPE_ID, AP_SURVEY_PRVODARCE_EVENT_TYPE_ID, AP_SURVEY_OBNOVENI_KVALIFIKACE_EVENT_TYPE_ID} from '../helpers/misc'
import {SurveyRegistrationCards} from '../components/surveys/SurveyRegistrationCards'
import {SurveyGuideCards} from '../components/surveys/SurveyGuideCards'
import {SurveyAnnualControlCards} from '../components/surveys/SurveyAnnualControlCards'

export class QuestionnairePage extends ReactComponent {
  surveyFormRef = createRef()

  state = {
    loading_page: false,
    complete: false,
    blocked_alert: false,
    gender: 1
  }

  async componentDidMount() {
    this.pushPageAnalytics('Dotazník - Moje Amber')

    const account = await this.$app.$store('account').getPersonalInfo()

    // block survey if invalid segment
    void this.updateState({
      blocked_alert: !(await this.$app.$store('account').isAllowedToShowSurvey(this.props.type)),
      gender: account.gender
    })
  }

  getFormTitle(type) {
    switch (type) {
      case 'annual':
        return 'Dotazník - Roční prohlídku'
      case 'registration':
        return 'Dotazník - Registrace'
      case 'guide':
        return 'Dotazník - Průvodka'
      case 'prvodarce':
        return 'Dotazník - Prvodárce'
      case 'obnoveni_kvalifikace':
        return 'Dotazník - Obnovení kvalifikace'
      default:
        return "Dotazník"
    }
  }

  getEventTypeID(type) {
    switch (type) {
      case 'annual':
        return AP_SURVEY_ANNUAL_EVENT_TYPE_ID
      case 'registration':
        return AP_SURVEY_REGISTRATION_EVENT_TYPE_ID
      case 'guide':
        return AP_SURVEY_GUIDE_EVENT_TYPE_ID
      case 'prvodarce':
        return AP_SURVEY_PRVODARCE_EVENT_TYPE_ID
      case 'obnoveni_kvalifikace':
        return AP_SURVEY_OBNOVENI_KVALIFIKACE_EVENT_TYPE_ID
    }
  }

  async submitForm() {
    let event_type_id = this.getEventTypeID(this.props.type)


    void this.updateState({loading_page: true})

    try {
      const survey_data = this.surveyFormRef.current.getSurveyData()
      const external_id = randomString()

      await this.$api({
        action: 'carecloud_api',
        method: 'POST',
        route: 'events',
        data: {
          event: {
            event_type_id,
            customer_id: '{customer_id}',
            external_id
          },
          property_records: [
            {
              property_id: PROPERTY_AP_SURVEY_KEY,
              property_value: JSON.stringify(survey_data)
            }
          ]
        }
      })

      void this.updateState({complete: true})

    } catch (error) {

      console.log(error)

    } finally {

      this.scrollToTop()

      void this.updateState({loading_page: false})

    }
  }

  render() {
    return (
      <Layout tagName="main" className={'survey-page ' + (Number(this.state.gender) === 2 ? 'female' : 'male')}>
        <Row align="center">
          <Col md={24}>
            <h1>{this.getFormTitle(this.props.type)}</h1>
          </Col>

          {this.state.blocked_alert &&

            <Result
              title="Dotazník není k dispozici."
              extra={
                <Link to={'/'}>
                  <Button type="default" size="large">Domů</Button>
                </Link>
              }
            />

          }

          {this.state.complete &&

            <Card bordered={false} style={{maxWidth: 680, width: '100%'}} className="card register">
              <Result
                status="success"
                title="Dotazník odeslán"
                subTitle="Děkujeme Vám za vyplnění dotazníku."
                extra={
                  <Link to="/">
                    <Button type="default" className={'btn btn-primary'} size="large">Domů</Button>
                  </Link>
                }/>
            </Card>

          }

          {!this.state.blocked_alert && !this.state.complete &&

            <Col sm={24} md={18} lg={16} xl={12} className="survey-cards-container">
              <Spin spinning={this.state.loading_page} size={'large'}>

                {this.props.type === 'annual' &&
                  <SurveyAnnualControlCards
                    ref={this.surveyFormRef}
                    gender={this.state.gender.toString()}
                    type={this.props.type}
                    submitButton={<Button onClick={() => {
                      void this.submitForm()
                    }} className="btn btn-primary">Odeslat Formulář</Button>}/>

                }

                {(this.props.type === 'registration' || this.props.type === 'obnoveni_kvalifikace') &&
                  <SurveyRegistrationCards
                    ref={this.surveyFormRef}
                    gender={this.state.gender.toString()}
                    type={this.props.type}
                    submitButton={<Button onClick={() => {
                      void this.submitForm()
                    }} className="btn btn-primary">Odeslat Formulář</Button>}/>
                }

                {(this.props.type === 'guide' || this.props.type === 'prvodarce') &&
                  <SurveyGuideCards
                    ref={this.surveyFormRef}
                    gender={this.state.gender.toString()}
                    type={this.props.type}
                    submitButton={<Button onClick={() => {
                      void this.submitForm()
                    }} className="btn btn-primary">Odeslat Formulář</Button>}/>
                }

              </Spin>
            </Col>

          }

        </Row>
      </Layout>
    )
  }
}